import { ErrorLike } from 'gf-types';
import { GetAppSettings } from '../AppSettings';
import { AxiosError } from 'axios';

type LogOptions = { force?: boolean; logToConsole?: boolean };

export function InitializeRaygun() {
  const appSettings = GetAppSettings();
  if (!window.rg4js) {
    return;
  }

  window.rg4js('apiKey', appSettings?.Raygun?.ApiKey);
  rg4js('options', {
    ignoreAjaxAbort: true,
    ignore3rdPartyErrors: true
  });
  window.rg4js('logContentsOfXhrCalls', true);
  window.rg4js('enableCrashReporting', true);
  window.rg4js('setAutoBreadcrumbsXHRIgnoredHosts', ['api.segment.io']);
}

export const raygunIdentify = (id, data) => {
  if (!window.rg4js) {
    return;
  }

  window.rg4js('setUser', { ...data, isAnonymous: false, identifier: id });
};

export function raygunPage(route: string, pathname: string) {
  if (!window.rg4js) {
    return;
  }

  window.rg4js('trackEvent', { type: 'pageView', path: pathname });
  window.rg4js('recordBreadcrumb', `Viewed Page ${pathname}`, { route: route, path: pathname });
}

/**
 * Directly send non-http errors to raygun.
 *
 * @param error The error to log.
 * @param options The log options
 */
export function raygunSendError(error: ErrorLike, { force, logToConsole }: LogOptions = {}) {
  if (logToConsole) {
    console.error(error);
  }

  if (force) {
    window.rg4js('send', error);
    return;
  }

  // only log errors that aren't axios errors
  if (error instanceof AxiosError) {
    return;
  }

  window.rg4js('send', error);
}
